var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"noselect",attrs:{"id":"app"}},[_c('router-view',{attrs:{"language":_vm.language,"languages":_vm.languages,"theme":_vm.theme,"themes":_vm.themes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }